var _typeof = require("@babel/runtime/helpers/typeof");

!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], n) : n((t = t || self).ReactStepWizard = {}, t.React);
}(this, function (t, o) {
  "use strict";

  var r = "default" in o ? o.default : o;

  function i(t) {
    return (i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    })(t);
  }

  function s(t, n) {
    for (var e = 0; e < n.length; e++) {
      var a = n[e];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }

  function c(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[n] = e, t;
  }

  function p(t) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function f(t, n) {
    return (f = Object.setPrototypeOf || function (t, n) {
      return t.__proto__ = n, t;
    })(t, n);
  }

  function u(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function n(t, n) {
    void 0 === n && (n = {});
    var e = n.insertAt;

    if (t && "undefined" != typeof document) {
      var a = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style");
      o.type = "text/css", "top" === e && a.firstChild ? a.insertBefore(o, a.firstChild) : a.appendChild(o), o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t));
    }
  }

  var l = "rsw_1z",
      d = "rsw_1M",
      h = "rsw_19",
      m = "rsw_3C",
      y = "rsw_1u";
  n("/**\n * Snippets from animate.css\n * Credit goes to https://github.com/daneden\n * github.com/daneden/animate.css\n*/\n.rsw_1z {\n  -webkit-animation-duration: .8192s;\n  animation-duration: .8192s;\n  -webkit-animation-fill-mode: backwards;\n  animation-fill-mode: backwards;\n}\n\n/** fadeInRight */\n@-webkit-keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_1M {\n  -webkit-animation-name: rsw_1M;\n  animation-name: rsw_1M;\n}\n\n/** fadeInLeft */\n@-webkit-keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_19 {\n  -webkit-animation-name: rsw_19;\n  animation-name: rsw_19;\n}\n\n/** fadeOutRight */\n@-webkit-keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.rsw_3C {\n  -webkit-animation-name: rsw_3C;\n  animation-name: rsw_3C;\n}\n\n/** fadeOutLeft */\n@-webkit-keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.rsw_1u {\n  -webkit-animation-name: rsw_1u;\n  animation-name: rsw_1u;\n}\n");
  var w = "rsw_2Y",
      v = "rsw_2f",
      S = "rsw_3G";
  n("/** Step Wizard */\n.rsw_2Y {\n    position: relative;\n}\n\n.rsw_2f {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 0;\n}\n\n.rsw_3G {\n    opacity: 1;\n    pointer-events: inherit;\n    position: relative;\n    z-index: 1;\n}\n");

  var e = function () {
    function a(t) {
      var o, n, e;
      return function (t, n) {
        if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, a), n = this, e = p(a).call(this, t), o = !e || "object" != _typeof(e) && "function" != typeof e ? u(n) : e, c(u(o), "initialState", function () {
        var e = {
          activeStep: 0,
          classes: {},
          hashKeys: {}
        },
            t = "object" === ("undefined" == typeof window ? "undefined" : i(window)) ? o.getHash() : "",
            n = r.Children.toArray(o.getSteps());
        n.forEach(function (t, n) {
          e.hashKeys[n] = t.props && t.props.hashKey || "step".concat(n + 1), e.hashKeys[e.hashKeys[n]] = n;
        });
        var a = o.props.initialStep - 1;
        return a && n[a] && (e.activeStep = a), o.props.isHashEnabled && t && void 0 !== e.hashKeys[t] && (e.activeStep = e.hashKeys[t]), o.props.transitions && (e.classes[e.activeStep] = o.props.transitions.intro || ""), e;
      }), c(u(o), "getHash", function () {
        return decodeURI(window.location.hash).replace(/^#/, "");
      }), c(u(o), "getTransitions", function () {
        return o.props.transitions || {
          enterRight: "".concat(l, " ").concat(d),
          enterLeft: "".concat(l, " ").concat(h),
          exitRight: "".concat(l, " ").concat(m),
          exitLeft: "".concat(l, " ").concat(y)
        };
      }), c(u(o), "onHashChange", function () {
        var t = o.state.hashKeys[o.getHash()];
        void 0 !== t && o.setActiveStep(t);
      }), c(u(o), "isInvalidStep", function (t) {
        return t < 0 || t >= o.totalSteps;
      }), c(u(o), "setActiveStep", function (t) {
        var n = o.state.activeStep;
        if (n !== t) if (o.isInvalidStep(t)) console.error("".concat(t + 1, " is an invalid step"));else {
          var e = o.state.classes,
              a = o.getTransitions();
          n < t ? (e[n] = a.exitLeft, e[t] = a.enterRight) : (e[n] = a.exitRight, e[t] = a.enterLeft), o.setState({
            activeStep: t,
            classes: e
          }, function () {
            o.onStepChange({
              previousStep: n + 1,
              activeStep: t + 1
            });
          });
        }
      }), c(u(o), "onStepChange", function (t) {
        o.props.onStepChange(t), o.props.isHashEnabled && o.updateHash(o.state.activeStep);
      }), c(u(o), "getSteps", function () {
        return o.props.children.filter(function (t) {
          return t;
        });
      }), c(u(o), "firstStep", function () {
        return o.goToStep(1);
      }), c(u(o), "lastStep", function () {
        return o.goToStep(o.totalSteps);
      }), c(u(o), "nextStep", function () {
        return o.setActiveStep(o.state.activeStep + 1);
      }), c(u(o), "previousStep", function () {
        return o.setActiveStep(o.state.activeStep - 1);
      }), c(u(o), "goToStep", function (t) {
        return o.setActiveStep(t - 1);
      }), c(u(o), "updateHash", function (t) {
        window.location.hash = o.state.hashKeys[t];
      }), c(u(o), "isReactComponent", function (t) {
        var n = t.type;
        return "function" == typeof n || "object" === i(n);
      }), o.state = o.initialState(), o;
    }

    var t, n, e;
    return function (t, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), n && f(t, n);
    }(a, o.PureComponent), t = a, (n = [{
      key: "componentDidMount",
      value: function value() {
        this.props.isHashEnabled && window.addEventListener("hashchange", this.onHashChange), this.props.instance(this);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.isHashEnabled && window.removeEventListener("hashchange", this.onHashChange);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            a = {
          currentStep: this.currentStep,
          totalSteps: this.totalSteps,
          nextStep: this.nextStep,
          previousStep: this.previousStep,
          goToStep: this.goToStep,
          firstStep: this.firstStep,
          lastStep: this.lastStep
        },
            o = this.state.classes,
            t = r.Children.map(this.getSteps(), function (t, n) {
          return t ? (a.isActive = n === e.state.activeStep, a.transitions = o[n], !e.props.isLazyMount || e.props.isLazyMount && a.isActive ? r.createElement(b, a, e.isReactComponent(t) ? r.cloneElement(t, a) : t) : null) : null;
        });
        return r.createElement("div", {
          className: this.props.className
        }, this.props.nav && r.cloneElement(this.props.nav, a), r.createElement("div", {
          className: w
        }, t));
      }
    }, {
      key: "currentStep",
      get: function get() {
        return this.state.activeStep + 1;
      }
    }, {
      key: "totalSteps",
      get: function get() {
        return this.getSteps().length;
      }
    }]) && s(t.prototype, n), e && s(t, e), a;
  }();

  e.defaultProps = {
    children: [],
    className: null,
    initialStep: 1,
    instance: function instance() {},
    isHashEnabled: !1,
    isLazyMount: !1,
    nav: null,
    onStepChange: function onStepChange() {},
    transitions: void 0
  };

  var b = function b(t) {
    var n = t.children,
        e = t.isActive,
        a = t.transitions;
    return r.createElement("div", {
      className: "".concat(v, " ").concat(a, " ").concat(e ? S : "").trim()
    }, n);
  };

  process.env.NODE_ENV, b.defaultProps = {
    children: [],
    isActive: !1,
    transitions: ""
  }, t.Step = b, t.default = e, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});